import React,{useEffect} from 'react'
//import { useSelector } from 'react-redux'
import { 
 
    Route,
    Routes,     
    Navigate,
    Outlet,
  
   } from 'react-router-dom'

import Home from './Pages/Home'
import Podcasts from './Pages/Podcasts';
import Schools from './Pages/Schools';
import SchoolProfile from './Pages/SchoolProfile';
import ResultLanding from './Pages/ResultLanding';
import TseResult from './Pages/TseResult';
import TermsAndConditions from './Pages/TermsAndConditions';
import Privacypolicy from './Pages/Privacypolicy';
import RefundPolicy from './Pages/RefundPolicy';
import ExamPriceCerimony from './Pages/ExamPriceCerimony';
import ExamAnswerSheet from './Pages/ExamAnswersheet';
import ShatabdiResult from './Pages/ShatabdiResult';

function AppRoutes() {
  
    const ProtectedRoute = ({
        isAllowed,
        redirectPath = '/',
        children,
      }) => {
        if (!isAllowed) {
          return <Navigate to={redirectPath} replace />;
        }
      
        return children ? children : <Outlet />;
      };
  return (
    <>
 
   <Routes>
        <Route index element={<Home/>}/>
        <Route path="/schools" element={<Schools/>}/>
        <Route path="/schoolprofile" element={<SchoolProfile/>}/>
        <Route path="/resultlanding" element={<ResultLanding/>}/>
        <Route path="/tseresult" element={<TseResult/>}/>

        {/* <Route path="/tseresult" element={<TseResult/>}/> */}
        <Route path="/shatabdiresult" element={<ShatabdiResult/>}/>

        <Route path="/terms-conditions" element={<TermsAndConditions/>}/>
        <Route path="/privacy-policy" element={<Privacypolicy/>}/>
        <Route path="/refund-policy" element={<RefundPolicy/>}/>
        <Route path="/priceCerimony" element={<ExamPriceCerimony/>}/>
        <Route path="/examanswersheet" element={<ExamAnswerSheet/>}/>

        {/* <Route element={<ProtectedRoute isAllowed={isLoggedin} />}>
        <Route path="dashboard" element={<Dashboard/>}/>
        <Route path="/course" element={<Course/>}/>
        <Route path="/coursecontent" element={<CourseContent/>}/>
        <Route path="/coursepackage" element={<CoursePackage/>}/>

       
        </Route> */}
    </Routes>
  
  
    </>
  )
}

export default AppRoutes